module.exports = __webpack_public_path__ + "media/images/icon_login-372bbf050d9387cee26f45f9c0b7cc68.png";